// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cls-1[data-v-c277bf4a] {\n  fill: none;\n  stroke: currentColor;\n  stroke-miterlimit: 10;\n  stroke-width: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
